import { domainName, googleMapKey, productionMode, publicKey, hotjarId, resizeImageGateway, onetrustDataDomainScript, clarityKey, reCaptchaSiteKey, envName, prefixCookieName, googleTagManagerId, googleTagManagerAuth, googleTagManagerPreview } from './properties';

const serviceEndpoint = {
  frontendService: `${domainName.frontend}`,
  adaptorService: `${domainName.service}/adaptor`,
  searchService: `${domainName.service}/search-api`,
  backendService: `${domainName.backend}`,
  bookingService: `${domainName.service}/booking`,
  cartV4Service: `${domainName.service}/cart-v4`,
  paymentService: `${domainName.service}/payment`,
  paymentV2Service: `${domainName.service}/payment-v2`,
  controlService: `${domainName.service}/control`,
  aadService: `${domainName.service}/aadauthen`,
  accountService: `${domainName.service}/account`,
  integrationService: `${domainName.service}/integration`,
  reportService: `${domainName.service}/report`,
  reportV2Service: `${domainName.service}/report-v2`,
  hotelService: `${domainName.service}/hotel`,
  reviewService: `${domainName.service}/review`,
  documentService: `${domainName.service}/document`,
  bookingV2Service: `${domainName.service}/booking-v2`,
  companyService: `${domainName.service}/company`,
  ascendTravelAuthorization: `${domainName.service}/ascendtravel-authorization`,
  userService: `${domainName.service}/user`,
  companyV2Service: `${domainName.service}/company-v2`,
  authenticationCenter: `${domainName.service}/authentication-center`,
  creditService: `${domainName.service}/credit`,
  promotionService: `${domainName.service}/promotion`,
};

export const environment = {
  googleTagManagerId: googleTagManagerId,
  googleTagManagerAuth: googleTagManagerAuth,
  googleTagManagerPreview: googleTagManagerPreview,
  production: productionMode,
  hotjarId: hotjarId,
  publicKey: `${publicKey}`,
  googleMapKey: `${googleMapKey}`,
  reCaptchaSiteKey: reCaptchaSiteKey,
  envName: envName,
  prefixCookieName: prefixCookieName,
  endpoint: {
    // Authentication
    'refreshToken': `${serviceEndpoint.authenticationCenter}/api/v1/user/token`,
    'authorizeRequest': `${serviceEndpoint.authenticationCenter}/api/v1/authorize`,
    'getTokenAuthen': `${serviceEndpoint.authenticationCenter}/api/v1/token`,
    'loginAuthen': `${serviceEndpoint.authenticationCenter}/api/v1/user/login`,
    'consent': `${serviceEndpoint.authenticationCenter}/api/v1/authorize/consent`,
    'sendEmailForgetPassword': `${serviceEndpoint.authenticationCenter}/api/v1/user/forget-password`,
    'resetPassword': `${serviceEndpoint.authenticationCenter}/api/v1/user/reset-password`,
    'verifyUserExist': `${serviceEndpoint.authenticationCenter}/api/v1/user/exist`,
    'verifyRegisterEmail': `${serviceEndpoint.authenticationCenter}/api/v1/user/verify`,
    'changePassword': `${serviceEndpoint.authenticationCenter}/api/v1/user/password`,
    'sendEmailRegisterVerify': `${serviceEndpoint.authenticationCenter}/api/v1/user/verify/resend`,
    'publicKeyPIN': `${serviceEndpoint.authenticationCenter}/api/v1/key/public`,
    'userPINExists': `${serviceEndpoint.authenticationCenter}/api/v1/user/{userId}/pin/exists`,
    'setupPIN': `${serviceEndpoint.authenticationCenter}/api/v1/user/pin`,
    'verifyPIN': `${serviceEndpoint.authenticationCenter}/api/v1/pin/verify`,
    'requestOTP': `${serviceEndpoint.authenticationCenter}/api/v1/otp/request`,
    'verifyOTP': `${serviceEndpoint.authenticationCenter}/api/v1/otp/verify`,
    'userPhone': `${serviceEndpoint.authenticationCenter}/api/v1/user/phone`,

    // billing address
    'getFeature': `${serviceEndpoint.accountService}/api/1.0/users/features`,
    'getBilling': `${serviceEndpoint.accountService}/api/1.0/users/billing/list`,
    'createBilling': `${serviceEndpoint.accountService}/api/1.0/users/billing/create`,
    'updateBilling': `${serviceEndpoint.accountService}/api/1.0/users/billing/update`,
    'deleteBilling': `${serviceEndpoint.accountService}/api/1.0/users/billing/{billingId}`,

    // user service
    'creditterm': `${serviceEndpoint.adaptorService}/api/v1/user/creditterm`,
    'getAllCompanyUser': `${serviceEndpoint.companyV2Service}/api/v2/user/companies`,
    'loginV2': `${serviceEndpoint.userService}/api/v2/user/login`,
    'getCallingCode': `${serviceEndpoint.userService}/api/v2/act/country/calling-code/list`,
    'userInfo': `${serviceEndpoint.userService}/api/v2/user/information`,
    'travellerSuggest': `${serviceEndpoint.userService}/api/v2/user/search/suggest`,
    'travellerDetail': `${serviceEndpoint.userService}/api/v3/traveller`,
    'userSetting': `${serviceEndpoint.userService}/api/v2/user/:userId/setting`,

    // search service
    'getSearchSuggestion': `${serviceEndpoint.searchService}/api/v2/GetSearchSuggestion`,
    'getProductList': `${serviceEndpoint.searchService}/api/v2/hotels`,
    'getProductListWithPOI': `${serviceEndpoint.searchService}/api/v2/hotels/poi`,
    'getProductDetail': `${serviceEndpoint.searchService}/api/v2/hotel/detail`,
    'getProductRoomDetail': `${serviceEndpoint.searchService}/api/v3/room/detail`,
    'getProductOptionDetail': `${serviceEndpoint.searchService}/api/v3/room/more/detail`,
    'getProductNearBy': `${serviceEndpoint.searchService}/api/v2/hotels/nearby`,

    // search service v3
    'getProductListWithPOIV3': `${serviceEndpoint.searchService}/api/v3/hotels/poi`,
    'getHotelList': `${serviceEndpoint.searchService}/api/v3/hotels`,
    'getTopHoteList': `${serviceEndpoint.searchService}/api/v3/hotels/top`,
    'getAdsHotelByDestination': `${serviceEndpoint.searchService}/api/v3/hotels/ranking-ads/destination`,
    'getAdsHotelByPOI': `${serviceEndpoint.searchService}/api/v3/hotels/ranking-ads/poi`,
    'getCurrencies': `${serviceEndpoint.searchService}/api/v3/currencies`,

    // cart service
    'addToCartV4': `${serviceEndpoint.cartV4Service}/api/v4/cart`,
    'getCartV4Checkout': `${serviceEndpoint.cartV4Service}/api/v4/cart/{cartId}/checkout`,

    // Home module
    'getProductListByCategory': `${serviceEndpoint.searchService}/api/GetProductListByCategory`,
    'registerMember': `${serviceEndpoint.userService}/api/v2/user/register`,

    // Profile module
    'getProfile': `${serviceEndpoint.userService}/api/v2/user/profile`,
    'editProfile': `${serviceEndpoint.userService}/api/v2/user/:userId`,
    'editProfileAllCompany': `${serviceEndpoint.userService}/api/v2/companies/user/:userId`,
    'editTaxAddress': `${serviceEndpoint.userService}/api/v2/taxaddress/edit`,
    'addTaxAddress': `${serviceEndpoint.userService}/api/v2/taxaddress/add`,
    'getAcceptPrivacyNote': `${serviceEndpoint.userService}/api/v2/user/acceptPrivacyNote`,
    'getUserConsentDetail': `${serviceEndpoint.userService}/api/v2/user/:userId/consent/:name`,
    'getConsentDetail': `${serviceEndpoint.userService}/api/v2/consent/:name`,
    'updateUserConsent': `${serviceEndpoint.userService}/api/v2/user/:userId/consent`,
    'getPurposeByUserId': `${serviceEndpoint.userService}/api/v2/user/:userId/consent/:name/purpose`,
    'updatePurposeByUserId': `${serviceEndpoint.userService}/api/v2/user/:userId/consent/purpose/:action`,

    // Booking Service
    'getBookingList': `${serviceEndpoint.bookingV2Service}/api/v2/my-booking/list`,
    'getBookingCancellationFee': `${serviceEndpoint.bookingV2Service}/api/v2/booking/:bookingId/cancellation/detail`,
    'getBookingDetails': `${serviceEndpoint.bookingV2Service}/api/v2/my-booking`,
    'getBookingSuggestion': `${serviceEndpoint.bookingV2Service}/api/v2/my-booking/suggest`,
    'cancelBooking': `${serviceEndpoint.bookingV2Service}/api/v2/cancel/booking/`,
    'cancelOldBooking': `${serviceEndpoint.frontendService}/api/BookingCancel`,
    'getOldBookingPDF': `${serviceEndpoint.frontendService}/eng/{bookingID}/download.html`,
    'getBookingReport': `${serviceEndpoint.reportV2Service}/api/v2/booker/accrued/creditterm`,
    'getBookingReportUrl': `${serviceEndpoint.reportV2Service}/api/v2/report/url`,
    'getBookingVoucherPDF': `${serviceEndpoint.documentService}/api/v2/document/customer/voucher`,
    'downloadDocument': `${serviceEndpoint.documentService}/api/v2/my-booking/document`,
    'preBookingValidatePromotionCode': `${serviceEndpoint.bookingV2Service}/api/v3/pre-book/validate/promotion-code`,
    'getPreBookingPromotionCodeList': `${serviceEndpoint.bookingV2Service}/api/v3/pre-book/promotion-code/list`,

    // Control Service
    'createOrder': `${serviceEndpoint.controlService}/api/v1/createOrder`,
    'checkBookingApprovalStatus': `${serviceEndpoint.controlService}/api/v1/approval/status`,
    'updateBookingApprovalStatus': `${serviceEndpoint.controlService}/api/v1/approval`,

    // Approval Service
    'getApprovalList': `${serviceEndpoint.bookingV2Service}/api/v2/approval/booking/list`,
    'getApprovalDetails': `${serviceEndpoint.bookingV2Service}/api/v2/approval/booking/{bookingID}/detail`,
    'getApprovalSuggestion': `${serviceEndpoint.bookingV2Service}/api/v2/approval/suggestion`,
    'approve': `${serviceEndpoint.bookingV2Service}/api/v2/booking/approve`,
    'reject': `${serviceEndpoint.bookingV2Service}/api/v2/booking/approval/reject`,

    // Payment Service
    'validateCreditCart': `${serviceEndpoint.paymentV2Service}/api/v2/credit-card/validate/`,

    // scb
    'scb': `${serviceEndpoint.frontendService}/sa2017`,

    // Integration Service
    'getUrlAuthenRequest': `${serviceEndpoint.integrationService}/api/:affiliate/authenticate`,
    'getAffiliateConsume': `${serviceEndpoint.integrationService}/api/:affiliate/consume`,
    'loginAffiliate': `${serviceEndpoint.integrationService}/api/:affiliate/login`,
    'logoutAffiliate': `${serviceEndpoint.integrationService}/api/:affiliate/logout`,
    'getTaxAddress': `${serviceEndpoint.integrationService}/api/getTaxAddress/:affiliate/:costCenterCode`,

    // Review Service
    'rating': `${serviceEndpoint.reviewService}/api/v2/rating/:token`,
    'getHotelReviewList': `${serviceEndpoint.reviewService}/api/v2/hotel/{hotelId}/review/list`,

    // Banner Service
    'getBannerHotelDealList': `${serviceEndpoint.hotelService}/api/v2/banner/hotel-deals`,
    'getBannerBillboard': `${serviceEndpoint.hotelService}/api/v2/banner/billboard`,
    'getBannerOverlay': `${serviceEndpoint.hotelService}/api/v2/banner/overlay`,
    'getBannerLeaderboard': `${serviceEndpoint.hotelService}/api/v2/banner/leaderboard`,

    // Confirm Supplier Service
    'supplierConfirmation': `${serviceEndpoint.bookingV2Service}/api/v2/supplier/booking/confirmation/status`,
    'supplierConfirmationSubmitEmailConfirm': `${serviceEndpoint.bookingV2Service}/api/v2/supplier/booking/confirmation/acceptance`,
    'supplierConfirmationSubmitEmailReject': `${serviceEndpoint.bookingV2Service}/api/v2/supplier/booking/confirmation/rejection`,

    // Checkout Service
    'travellerManagement': `${serviceEndpoint.userService}/api/v2/user-guest`,
    'travellerBudget': `${serviceEndpoint.bookingV2Service}/api/v3/pre-book/validate/traveller/budget`,
    'travellerBudgetMultipayment': `${serviceEndpoint.bookingV2Service}/api/v3/pre-book/adjust/traveller/budget/multi-payment`,

    // Credit Service
    'budgetAvailable': `${serviceEndpoint.creditService}/api/v1/budget/available`,
    'getMyBudget': `${serviceEndpoint.creditService}/api/v1/my-budget/company/{companyId}/user/{userId}`,
    'getFleetCardInformation': `${serviceEndpoint.creditService}/api/v1/user/fleets`,
    'getTransactionHistory': `${serviceEndpoint.creditService}/api/v1/user/fleet/{fleetCardId}/history`,
    'registerFleetCard': `${serviceEndpoint.creditService}/api/v1/fleet/register`,
    'transferFleetCard': `${serviceEndpoint.creditService}/api/v1/user/fleet/transfer`,

    // Mice Module
    'miceQuotation': `${serviceEndpoint.hotelService}/api/v2/mice/quotation`,

    // Booking V2
    'createBooking': `${serviceEndpoint.bookingV2Service}/api/v3/booking/create`,
    'getBookingCancellationStatus': `${serviceEndpoint.bookingV2Service}/api/v2/booking/cancellation/status`,
    'getBookingStatus': `${serviceEndpoint.bookingV2Service}/api/v2/booking/:bookingId/booking/status`,
    'getBookingDetailsV2': `${serviceEndpoint.bookingV2Service}/api/v2/my-booking`,
    'uploadBookingDocument': `${serviceEndpoint.bookingV2Service}/api/v2/booking/document`,

    // Company V2
    'companyDomain': `${serviceEndpoint.companyV2Service}/api/v2/company/domain`,
    'insertJoinUs': `${serviceEndpoint.companyV2Service}/api/v2/company/join-us`,
    'getTaxInvoice': `${serviceEndpoint.companyV2Service}/api/v2/taxinvoice`,
    'validatePromotionCode': `${serviceEndpoint.companyV2Service}/api/v2/promotion/verify`,
    'companyShareBudget': `${serviceEndpoint.companyV2Service}/api/v2/user/companies/share-budget`,

    // Ascendtravel Authorization Service
    'getFeaturesActAuthz': `${serviceEndpoint.ascendTravelAuthorization}/api/v2/user/features`,
    'setBudgetSuggestion': `${serviceEndpoint.ascendTravelAuthorization}/api/v2/user/suggestion-budget`,
    'generateBudgetCode': `${serviceEndpoint.ascendTravelAuthorization}/api/v2/share-budget/generate/code`,
    'userShareCode': `${serviceEndpoint.ascendTravelAuthorization}/api/v2/share-budget/code/:code`,
    'companyCommunication': `${serviceEndpoint.ascendTravelAuthorization}/api/v2/user/communication-preference`,
    'companyCommunicationBanner': `${serviceEndpoint.ascendTravelAuthorization}/api/v2/user/communication-preference/banner`,
    'preApprovalDetail': `${serviceEndpoint.ascendTravelAuthorization}/api/v2/pre-approval-requests/:approvalRequestId`,

    // API Gateway
    'resizeUri': `${resizeImageGateway}/resize/image`,

    // Promotion
    'campaignTracking': `${serviceEndpoint.promotionService}/api/v2/campaign/{campaignId}/track-event`,
  },
  onetrustDataDomainScript: onetrustDataDomainScript,
  clarityKey: clarityKey,
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts